<template>
<div id="withdraw-02">
    <div class="container mt-4 pr-4 pl-4 pt-5">
        <otp-block-input v-model="otp" @requestNewOTP="requestNewOTP"></otp-block-input>
        <div class="row pt-4" v-if="isInvalidOTP">
            <div class="col number-bullet-xl-width-flex">
                <div class="number-bullet-xl rounded-circle d-flex align-items-center justify-content-center bg-danger-dimmed">
                    <p class="h3 font-weight-normal m-0 text-danger">!</p>
                </div>
            </div>
            <div class="col pl-0 d-flex align-items-center">
                <p class="text-danger m-0">รหัส OTP ของคุณไม่ถูกต้อง</p>
            </div>
        </div>
        <div class="mt-5 pb-2">
            <button :class="{disabled: otp.length !== 6}" @click="confirmOTPForWithdrawRequest()" class="btn btn-primary btn-lg btn-block">ยืนยันตัวตน</button>
            <button @click="cancelWithdrawRequest()" class="btn btn-light btn-lg btn-block">ย้อนกลับ</button>
        </div>
    </div>
</div>
</template>

<script>
export default {
    data: () => ({
        isProcessing: false,
        isInvalidOTP: false,
        isRequestingNewOTPCooldown: false,
        otp: '',
        request: {
            id: '',
            withdrawAmount: '',
            expire: ''
        }
    }),
    async created () {
        try {
            const result = await this.$api.withdraw.getUserCurrentStep()
            const data = result.data
            if (data.step !== 'PRE_VERIFY') this.$router.replace({ name: 'withdraw-01' })
            this.request = result.data.request
            this.isPreProcessing = false
        } catch (error) {
            console.error(error)
        }
    },
    methods: {
        async requestNewOTP () {
            this.isRequestingNewOTPCooldown = true
            try {
                await this.$api.withdraw.resendOTP()
                alert('ส่งรหัส OTP ใหม่แล้ว')
            } catch (error) {
                console.error(error)
            } 
        },
        async confirmOTPForWithdrawRequest () {
            this.isInvalidOTP = false
            this.isProcessing = true
            try {
                const result = await this.$api.withdraw.verifyOTP(this.otp)
                const data = result.data
                if (data.success) {
                    this.$router.replace({ name: 'withdraw-03' })
                } else {
                    this.isInvalidOTP = true;
                    this.otp = ''
                }
            } catch (error) {
                console.error(error)
            }
        },
        async cancelWithdrawRequest () {
            this.isProcessing = true
            try {
                await this.$api.withdraw.cancel(this.request.requestId)
                this.$router.replace({ name: 'withdraw-01' })
            } catch (error) {
                console.error(error)
            }
        }
    }
}
</script>

<style lang="scss">
</style>
